import React, {useEffect, useState} from "react"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import {useNavigate} from "react-router-dom"
import {useDroneEvents} from "@murphy-frontend/common/api/DroneEvents/Queries"
import {useStartEvent} from "@murphy-frontend/common/api/DroneEvents/Mutations"
import {StartEventDto} from "@murphy-frontend/common/api/DroneEvents/models"
import {FunctionComponent} from "react"
import {MurphyPossibleDroneEventDto} from "@murphy-frontend/common/interfaces/IDroneEventsApi"
import {useModal} from "@murphy-frontend/web-core/contexts/ModalContext"
import {ModalConfiguration} from "@murphy-frontend/web-core/components/Modal"
import TemplateConfirmModal from "./TemplateConfirmModal"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"

interface EventTemplatesProps {}

const EventTemplates: FunctionComponent<EventTemplatesProps> = () => {
	const [templates, setTemplates] = useState<MurphyPossibleDroneEventDto[]>([])
	const {customer} = useCustomer()
	const {openModal, closeModal} = useModal()

	const {translations} = useUserPreferences()
	const navigate = useNavigate()
	const {data: eventTemplates, isLoading: eventTemplatesIsLoading} = useDroneEvents(customer?.Id)
	const {mutate: startEvent, isPending: startEventIsPending} = useStartEvent(customer?.Id)

	const handleCreate = (templateId: number) => {
		const startEventDto: StartEventDto = {
			EventFlowTemplateId: templateId
		}

		startEvent(startEventDto, {
			onSuccess: res => {
				closeModal()
				navigate(`/startedeventflows/${res.openFlowIdId}`)
			},
			onSettled: () => {
				closeModal()
			}
		})
	}

	const onClickShowModal = (templateId: number, incident: string) => {
		const modalConf: ModalConfiguration = {
			body: (
				<TemplateConfirmModal
					templateId={templateId}
					customerId={customer?.Id}
					incident={incident}
					closeModal={closeModal}
					handleCreate={handleCreate}
					translations={translations}
				/>
			),
			position: "center",
			hideCloseIcon: true,
			buttonText: "Ok",
			hideButton: true
		}

		openModal(modalConf)
	}

	useEffect(() => {
		if (eventTemplates?.length) setTemplates(eventTemplates)
	}, [eventTemplates])

	if (eventTemplatesIsLoading || !templates) return null

	const colors = ["#E23232", "#0062B2", "#2D9E45", "#C19BB2"]

	return (
		<div className='templates-container'>
			<div className='template-subtext'>{translations.createIncidentDesc}</div>
			<div className='templates-wrapper'>
				{templates.map(_ => (
					<div
						key={_.Id}
						className='template-card card-container'
						style={{
							borderLeft: `2px solid ${colors[_.Type - 1]}`
						}}
						onClick={() => onClickShowModal(_.Id, _.Name)}
					>
						<h3>{_.Name}</h3>
						<div className='template-desc'>{_.Description}</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default EventTemplates
